module.exports = __webpack_public_path__ + "static/media/APA_H_REV_212x76.7b53b274.png";